<template>
    <ModalComponent
        :name="'editarEntrada-' + entrada.id"
        title="Editar precio"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormEntrada :entrada="entrada" :sesion="sesion" :recinto="true" :evento_id="evento_id" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <Button type="submit" name="button" id="editar-precio-anexo">Editar</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormEntrada from '../FormEntrada';

    export default {
        props: ['sesion', 'evento_id', 'entrada', 'region'],
        methods: {
            close(creado) {
                this.$emit('close', 'editarEntrada-' + this.entrada.id, creado);
            },
            editarEntrada() {
                this.entrada.filters = {};

                this.entrada.evento_id = this.evento_id;
                this.entrada.sesion_id = this.sesion.id;
                this.entrada.entrada_plaza_id = this.entrada.id;

                this.entrada.sale_start = moment(this.entrada.sale_start_zulu).format('YYYY-MM-DD HH:mm:ss');
                this.entrada.sale_stop = moment(this.entrada.sale_stop_zulu).format('YYYY-MM-DD HH:mm:ss');

                if (this.region) {
                    this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.plazas.tickets.editar'), this.entrada).then(res => {
                        this.$toast.success(res.data.message);
                        this.close(true);
                    });                
                } else {
                    this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.tickets.editar'), this.entrada).then(res => {
                        this.$toast.success(res.data.message);
                        this.close(true);
                    });
                }
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.editarEntrada();
                }
            },
        },
        components: {
            ModalComponent, FormEntrada
        }
    }
</script>
